@if (open) {
  <div class="ps-overlay" (click)="onBackdropClick($event)">
    <div class="ps-dialog" role="dialog" aria-modal="true" aria-labelledby="ps-title" (click)="$event.stopPropagation()">

      @if (modalState() === 'sale') {
        <!-- Header -->
        <header class="ps-head">
          <div class="min-w-0">
            <h2 id="ps-title" class="ps-title">Registrar venta</h2>
            <p class="ps-subtitle">Agrega los productos, elige el cliente y anota cómo pagó.</p>
          </div>
          <button type="button" class="ps-icon-btn" (click)="closeModal()" aria-label="Cerrar">
            <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke-width="1.75" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>
        </header>

        <div class="ps-body" [attr.data-pane]="mobilePane()">

          <!-- ===== Catalog ===== -->
          <section class="ps-catalog" aria-label="Productos">
            <div class="ps-search">
              <svg class="ps-search__icon size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input #searchInput type="search" [formControl]="searchForm.controls.searchTerm"
                placeholder="Buscar producto" aria-label="Buscar producto por nombre, SKU o categoría"
                class="ps-input ps-input--search" />
              @if (isSearching()) {
                <span class="ps-spinner ps-search__spinner" aria-hidden="true"></span>
              }
            </div>

            <div class="ps-catalog__list">
              @if (isLoading()) {
                <div role="status" aria-label="Cargando productos">
                  @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                    <div class="ps-product animate-pulse">
                      <div class="min-w-0 flex-1">
                        <div class="mb-2 h-4 w-40 max-w-full rounded bg-gray-200 dark:bg-gray-800"></div>
                        <div class="h-3 w-24 rounded bg-gray-100 dark:bg-gray-800/70"></div>
                      </div>
                      <div class="h-4 w-16 rounded bg-gray-200 dark:bg-gray-800"></div>
                    </div>
                  }
                </div>
              } @else if (products().length === 0) {
                <div class="ps-empty">
                  <p class="ps-empty__title">
                    {{ searchForm.controls.searchTerm.value ? 'Ningún producto coincide' : 'No tienes productos activos' }}
                  </p>
                  <p class="ps-empty__text">
                    {{ searchForm.controls.searchTerm.value ? 'Prueba con otra palabra o con el código SKU.' : 'Créalos en Productos para poder venderlos.' }}
                  </p>
                </div>
              } @else {
                <ul>
                  @for (product of products(); track product.productId) {
                    @let inCart = quantityInCart(product.productId);
                    <li>
                      <button type="button" class="ps-product ps-product--action" (click)="addProduct(product)"
                        [disabled]="product.stock === 0 || inCart >= product.stock"
                        [class.ps-product--picked]="inCart > 0"
                        [attr.aria-label]="'Agregar ' + product.name + ', ' + formatCurrency(product.price) + (inCart ? ', ' + inCart + ' en la venta' : '')">
                        <span class="min-w-0 flex-1">
                          <span class="ps-product__name">{{ product.name }}</span>
                          <span class="ps-product__meta">
                            @if (product.category) {
                              <span>{{ product.category }}</span>
                            }
                            <span class="ps-stock" [attr.data-state]="product.stock === 0 ? 'out' : product.stock <= 5 ? 'low' : 'ok'">
                              {{ product.stock === 0 ? 'Agotado' : product.stock + ' en stock' }}
                            </span>
                          </span>
                        </span>
                        <span class="ps-product__price">{{ formatCurrency(product.price) }}</span>
                        <span class="ps-product__add" aria-hidden="true">
                          @if (inCart > 0) {
                            {{ inCart }}
                          } @else {
                            <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.25" d="M12 5v14m7-7H5" /></svg>
                          }
                        </span>
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>
          </section>

          <!-- ===== Ticket ===== -->
          <section class="ps-side" aria-label="Venta">
            <button type="button" class="ps-back" (click)="mobilePane.set('catalog')">
              <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
              </svg>
              Agregar más productos
            </button>

            <div class="ps-ticket">
              <!-- Client -->
              <div class="ps-ticket__client">
                <div class="ps-ticket__row">
                  <span id="ps-client-label" class="ps-label">Cliente</span>
                  <div class="ps-segment" role="group" aria-labelledby="ps-client-label">
                    <button type="button" class="ps-segment__btn" [attr.aria-pressed]="useGenericClient()" (click)="toggleClientMode(true)">Genérico</button>
                    <button type="button" class="ps-segment__btn" [attr.aria-pressed]="!useGenericClient()" (click)="toggleClientMode(false)">Registrado</button>
                  </div>
                </div>
                @if (useGenericClient()) {
                  <p class="ps-hint">Venta de mostrador, sin guardar en el historial de un cliente.</p>
                } @else {
                  <div class="ps-lookup mt-2">
                    <app-client-lookup
                      [showMiniCard]="true"
                      [label]="''"
                      [placeholder]="'Busca por nombre, correo o teléfono'"
                      [selectedClient]="selectedClient()"
                      (clientSelected)="onClientSelected($event)"
                      (clientCleared)="onClientCleared()">
                    </app-client-lookup>
                  </div>
                }
              </div>

              <!-- Lines -->
              @if (selectedItems().length === 0) {
                <div class="ps-ticket__empty">
                  <p>Aún no hay productos en la venta.</p>
                  <p class="ps-hint">Toca un producto del catálogo para agregarlo.</p>
                </div>
              } @else {
                <ul class="ps-lines" aria-label="Productos en la venta">
                  @for (item of selectedItems(); track item.productId) {
                    <li class="ps-line">
                      <div class="ps-line__top">
                        <span class="ps-line__name">{{ getProductName(item.productId) }}</span>
                        <span class="ps-line__leader" aria-hidden="true"></span>
                        <span class="ps-line__amount">{{ formatCurrency(getItemTotal(item)) }}</span>
                      </div>
                      <div class="ps-line__bottom">
                        <div class="ps-stepper">
                          <button type="button" class="ps-stepper__btn" (click)="updateQuantity(item.productId, item.quantity - 1)"
                            [attr.aria-label]="item.quantity === 1 ? 'Quitar ' + getProductName(item.productId) : 'Quitar una unidad de ' + getProductName(item.productId)">
                            @if (item.quantity === 1) {
                              <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" /></svg>
                            } @else {
                              <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2.25" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" /></svg>
                            }
                          </button>
                          <input type="number" class="ps-stepper__value" [value]="item.quantity" min="1" [max]="getProductStock(item.productId)"
                            (change)="updateQuantity(item.productId, +$any($event.target).value)"
                            [attr.aria-label]="'Cantidad de ' + getProductName(item.productId)" />
                          <button type="button" class="ps-stepper__btn" (click)="updateQuantity(item.productId, item.quantity + 1)"
                            [disabled]="item.quantity >= getProductStock(item.productId)"
                            [attr.aria-label]="'Agregar una unidad de ' + getProductName(item.productId)">
                            <svg class="size-3.5" fill="none" viewBox="0 0 24 24" stroke-width="2.25" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M12 5v14m7-7H5" /></svg>
                          </button>
                        </div>
                        <span class="ps-line__unit">{{ formatCurrency(item.unitPrice) }} c/u</span>
                      </div>
                    </li>
                  }
                </ul>
              }

              <div class="ps-ticket__total" aria-live="polite">
                <span>Total</span>
                <strong>{{ formatCurrency(getTotalAmount()) || '$ 0' }}</strong>
              </div>
            </div>

            <!-- Payment -->
            @if (selectedItems().length > 0) {
              <div class="ps-pay">
                <div>
                  <p id="ps-method-label" class="ps-label">Cómo pagó</p>
                  <div class="ps-methods" role="group" aria-labelledby="ps-method-label">
                    @for (method of paymentMethods; track method.value) {
                      <button type="button" class="ps-method"
                        [attr.aria-pressed]="paymentForm.get('paymentMethod')?.value === method.value"
                        (click)="paymentForm.patchValue({ paymentMethod: method.value })">
                        {{ method.label }}
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label for="ps-paid" class="ps-label">Cuánto pagó</label>
                  <input id="ps-paid" type="text" inputmode="numeric" class="ps-input ps-input--money"
                    [value]="getPaidAmountDisplay()"
                    (input)="onPaidAmountInput($event)" (focus)="onPaidAmountFocus($event)" (blur)="onPaidAmountBlur($event)"
                    placeholder="$ 0"
                    [class.ps-input--error]="paidExceedsTotal()"
                    [attr.aria-invalid]="paidExceedsTotal()"
                    aria-describedby="ps-paid-hint" />
                  @if (paidExceedsTotal()) {
                    <p id="ps-paid-hint" class="ps-error" role="alert">El pago no puede superar el total de la venta.</p>
                  } @else if (pendingAfterPayment() > 0) {
                    <p id="ps-paid-hint" class="ps-hint ps-hint--due">Queda debiendo {{ formatCurrency(pendingAfterPayment()) }}.</p>
                  } @else {
                    <p id="ps-paid-hint" class="ps-hint">Si paga solo una parte, cambia el monto.</p>
                  }
                </div>

                <div>
                  <label for="ps-notes" class="ps-label">Nota <span class="ps-optional">opcional</span></label>
                  <input id="ps-notes" type="text" class="ps-input" [formControl]="paymentForm.controls.notes"
                    placeholder="Ej: pagó con billete de $ 100.000" />
                </div>
              </div>
            }

            <div class="ps-submit">
              <button type="button" class="ps-btn ps-btn--primary w-full" (click)="submitSale()"
                [disabled]="!canSubmit() || paymentForm.invalid || paidExceedsTotal()" [attr.aria-busy]="isSubmitting()">
                @if (isSubmitting()) {
                  <span class="ps-spinner" aria-hidden="true"></span>
                  Registrando venta…
                } @else if (selectedItems().length > 0) {
                  Registrar venta de {{ formatCurrency(getTotalAmount()) }}
                } @else {
                  Registrar venta
                }
              </button>
              @if (!isSubmitting() && !selectedClient()) {
                <p class="ps-hint text-center">Elige el cliente o cambia a Genérico.</p>
              }
            </div>
          </section>
        </div>

        <!-- Mobile: jump to the ticket -->
        @if (mobilePane() === 'catalog') {
          <div class="ps-mobile-bar">
            <button type="button" class="ps-btn ps-btn--primary ps-mobile-bar__btn" (click)="mobilePane.set('ticket')">
              <span>{{ cartItemCount() > 0 ? 'Ver venta, ' + cartItemCount() + ' producto' + (cartItemCount() !== 1 ? 's' : '') : 'Ver venta' }}</span>
              <strong>{{ formatCurrency(getTotalAmount()) || '$ 0' }}</strong>
            </button>
          </div>
        }

      } @else {
        <!-- ===== Success ===== -->
        <div class="ps-done">
          <div class="ps-done__ticket">
            <span class="ps-done__check" aria-hidden="true">
              <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" /></svg>
            </span>
            <h2 id="ps-title" class="ps-done__title">Venta registrada</h2>
            <p class="ps-done__total">{{ formatCurrency(lastSaleTotal()) }}</p>
            <dl class="ps-done__sum">
              <div><dt>Cobrado</dt><dd>{{ formatCurrency(lastPaidAmount()) || '$ 0' }}</dd></div>
              @if (lastSaleTotal() - lastPaidAmount() > 0) {
                <div class="ps-done__due"><dt>Por cobrar</dt><dd>{{ formatCurrency(lastSaleTotal() - lastPaidAmount()) }}</dd></div>
              }
            </dl>
          </div>

          <div class="ps-done__actions">
            @if (lastPaymentId()) {
              <button type="button" class="ps-btn ps-btn--primary w-full" (click)="downloadReceipt()" [disabled]="isDownloadingReceipt()">
                @if (isDownloadingReceipt()) {
                  <span class="ps-spinner" aria-hidden="true"></span>
                  Generando comprobante…
                } @else {
                  Descargar comprobante
                }
              </button>
              <button type="button" class="ps-btn ps-btn--ghost w-full" (click)="downloadReceipt('ticket')" [disabled]="isDownloadingReceipt()">
                Tirilla para impresora térmica (80 mm)
              </button>
              <p class="ps-hint text-center">Comprobante no fiscal. Media carta: caben dos por hoja.</p>
            }
            <button type="button" class="ps-btn ps-btn--ghost w-full" (click)="startNewSale()">Registrar otra venta</button>
            <button type="button" class="ps-link" (click)="closeModal()">Cerrar</button>
          </div>
        </div>
      }
    </div>
  </div>
}
